import selectComponent from 'utilities/select-component'
import Slick from 'vendor/slick';

export default class CtaCarousel {

    constructor(element) {
        this.$component = selectComponent(element)
        
        this.initCarousel()
    }

    initCarousel() {
        this.$component.slick({
        	//variableWidth: true,
        	slidesToShow: 1,
        	responsive: [
        		{
        			breakpoint: 520,
        			settings: {
        				dots:true
        			}
        		}
        	]
        })
    }
}